<template>
  <div>
    <v-app>
      <v-container>
        <!-- タイトル -->
        <v-row justify="center">
          <v-col cols="auto" class="text-h6 pb-0">{{ title }} </v-col>
        </v-row>

        <!-- エラー画像 -->
        <v-row justify="center" class="mt-8 mb-8">
          <v-img max-width="120" :src="iconUrl"></v-img>
        </v-row>

        <!-- テキスト -->
        <v-row align="center" justify="center" class="mt-4 pl-4 pr-4">
          <v-col cols="auto" class="text-body-1">{{ text }}</v-col>
        </v-row>
      </v-container>

      <!-- 詳細情報 -->
      <v-container class="pl-16 pr-16">
        <!-- エラー番号 -->
        <v-row align="center" v-show="errorNo">
          <v-col cols="6" class="text-body-2">エラー番号</v-col>
          <v-col class="text-body-2">{{ errorNo }}</v-col>
        </v-row>
        <!-- 注文番号 -->
        <v-row align="center" v-show="orderNo">
          <v-col cols="6" class="text-body-2">注文番号</v-col>
          <v-col class="text-body-2">{{ orderNo }}</v-col>
        </v-row>
      </v-container>

      <!-- 店舗情報 -->
      <v-container v-if="about != null" class="pl-16 pr-16">
        <v-row justify="center" align="center">
          <v-col cols="auto" class="text-body-2">店舗連絡先</v-col>
          <v-col cols="auto" class="text-body-2">
            <a :href="`tel:${about.phone}`">{{ about.phone }}</a>
          </v-col>
        </v-row>
      </v-container>

      <!-- footer -->
      <v-container>
        <!-- トーク画面へ移動 -->
        <v-row justify="center" class="mt-8">
          <v-btn
            v-if="linkTalkScreen"
            rounded
            class="custom-transform-class text-none"
            color="success"
            :href="linkTalkScreen"
            >トーク画面へ移動</v-btn
          >
        </v-row>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { payError, MSG_TYPE } from "./payConstants";
const IMAGE_SORRY = require("@/assets/sorry.png");

export default {
  data: () => ({
    errorNo: "",
    orderNo: "",

    // アイコン
    iconUrl: IMAGE_SORRY,
    title: "",
    text: "",
  }),
  created() {
    this.$store.state.appBar = false;
    this.$store.state.title = "お支払い";
    this.$store.state.cart = false;
  },
  mounted() {
    // 表示メッセージ設定
    const msgType = this.$route.query.type;
    this.bindMessages(msgType);

    // エラー情報
    this.errorNo = this.$route.query.errorNo;

    // 注文番号
    this.orderNo = this.$route.query.orderNo;
  },
  watch: {
    // DB 設定読み込んだ後に行う
    db: function () {
      this.showShopInfo();
      this.hideProgress();
    },
  },
  computed: {
    ...mapGetters(["about"]),
    ...mapGetters("settings", ["linkTalkScreen", "db"]),
  },
  methods: {
    ...mapActions(["showProgress", "hideProgress", "fetchAbout"]),
    bindMessages: function (msgType) {
      const message = payError.findMessage(msgType);
      this.title = message.title;
      this.text = message.text;
    },
    isShowShopInfo: function (msgType) {
      return (
        !msgType || msgType == MSG_TYPE.SERIOUS || msgType == MSG_TYPE.REFUND_NG
      );
    },
    showShopInfo: async function () {
      // 店舗情報表示
      const msgType = this.$route.query.type;
      const showShopInfo = this.isShowShopInfo(msgType);
      if (!showShopInfo) {
        return;
      }
      this.fetchAbout();
    },
  },
};
</script>
